import { useDispatch, useSelector } from "react-redux";

// Actions
import { openSingleCitySelectionForm } from "../../../actions/SingleCitySelectionFormActions";
import {
  downloadCityConfigExcelTemplate,
  uploadCityConfig,
} from "../../../actions/org/OrgCityConfigActions";

// Constants and Utils
import {
  ExcelFileTypes,
  FormDataTargets,
  OrgCityConfigTypes,
} from "../../../constants/GeneralConstants";
import { selectFile } from "../../../common-utils/file-utils/FileUtils";

// Components
import Spinner from "../../../components/spinner/Spinner";
import { LoadingData } from "../../../pages/org/OrgUtils";

// excel template download button
export function CityConfigDownloadTemplate({ selectedCityId, configType }) {
  const dispatch = useDispatch();

  // Selector
  const downloadLoading = useSelector(
    (state) => state.orgCityConfig.downloadCityConfigExcelTemplateLoading
  );

  // function
  function handleDownloadTemplate() {
    // downloading for which type (isTouchPoint = true)
    const isTouchPoint = configType === OrgCityConfigTypes.touchPoint;

    dispatch(downloadCityConfigExcelTemplate(configType, isTouchPoint));
  }

  // hide button if city not selected
  if (!selectedCityId) {
    return null;
  }

  return (
    <button
      className="btn btn-primary shadow-none rounded-md"
      onClick={handleDownloadTemplate}
      disabled={downloadLoading}
    >
      Download Template
      {downloadLoading && <Spinner className="spinner-border-sm ml-2" />}
    </button>
  );
}

// City Select Section
export function CitySelectSection({ regionsName = [], selectedCityId }) {
  const dispatch = useDispatch();

  // selected region data
  const selectedRegion = regionsName.find((item) => item.id === selectedCityId);
  const { label: regionName } = selectedRegion || {};

  return (
    <div className="d-flex align-items-center">
      <h5 className="mb-0 mr-2">Selected City : </h5>
      <button
        type="button"
        className="btn border rounded-lg shadow-none px-3 dropdown-toggle"
        data-toggle="modal"
        data-target={`#${FormDataTargets.singleCitySelectionForm}`}
        onClick={() => dispatch(openSingleCitySelectionForm())}
      >
        {regionName ? regionName : "Select"}
      </button>
    </div>
  );
}

// upload city config Excel
export function UploadCityConfigExcel({ selectedCityId, configType }) {
  const dispatch = useDispatch();

  // Selector
  const uploadLoading = useSelector(
    (state) => state.orgCityConfig.uploadCityConfigLoading
  );

  // hide button if city not selected
  if (!selectedCityId) {
    return null;
  }

  // function
  async function handleUpload() {
    // uploading for which type (isTouchPoint = true)
    const isTouchPoint = configType === OrgCityConfigTypes.touchPoint;

    // files
    const files = await selectFile(false, ExcelFileTypes);

    // upload api
    dispatch(uploadCityConfig(selectedCityId, files, configType, isTouchPoint));
  }

  return (
    <button
      className="btn btn-primary shadow-none rounded-md"
      onClick={handleUpload}
      disabled={uploadLoading}
    >
      Upload Excel
      {uploadLoading && <Spinner className="spinner-border-sm ml-2" />}
    </button>
  );
}

// City Config Data Section
export function CityConfigDataSection({ configType = "", selectedCityId }) {
  // city config
  const cityConfig = useSelector((state) => state.orgCityConfig.cityConfig);
  const cityConfigLoading = useSelector(
    (state) => state.orgCityConfig.cityConfigLoading
  );

  // loading
  if (cityConfigLoading) {
    return <LoadingData className="p-1 mt-4" dataType={configType} />;
  }

  // config type values
  const cityConfigTypeData = cityConfig[configType] || {};
  const cityConfigTypeDataKeys = Object.keys(cityConfigTypeData);
  const isDataPresent = cityConfigTypeDataKeys.length > 0;

  // no data message
  if (selectedCityId && !isDataPresent) {
    return <p className="font-italic text-muted mt-4">No Data Present</p>;
  }

  return (
    <div className="mt-4">
      {cityConfigTypeDataKeys.map((key, i) => {
        const { label, types } = cityConfigTypeData[key];
        return (
          <div key={i} className="mb-5">
            <h5>{label}</h5>
            <ul className="row">
              {types.map((type, i) => (
                <li key={i} title={type} className="col-3 pl-0">
                  {type}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
